export default "__VITE_ASSET__Ce2bfSpz__"